import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InvoicePDF from '../Pdf/documents/InvoicePDF';
//Utils
import { RenderIf } from '../utils/RenderIf';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
//IMG
import defaultImage from "../../assets/img/default.png";

const ModalQuoteDetails = ({ show, onClose, quote, branchOfficeData, logo, onShare }) => {



  if (!quote) return null;

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="xl"
      contentClassName="p-0 border-0"
      dialogClassName="modal-quote-details-dialog"
      style={{ borderRadius: 32 }}
    >
      <div
        className="modal-quote-details shadow-lg"
        style={{
          borderRadius: 32,
          background: '#fff',
          padding: 0,
          boxSizing: 'border-box',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Acciones */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom" style={{ borderTopLeftRadius: 32, borderTopRightRadius: 32, background: '#fff', color: '#222' }}>
          <div className="fw-bold" style={{ color: '#1976d2' }}>Acciones</div>
          <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm" style={{ color: '#fff' }} onClick={onShare}>
              <i className="uil uil-share"></i> Compartir
            </button>
            <PDFDownloadLink
              document={
                <InvoicePDF
                  data={{
                    emisor: quote.branchoffice?.fiscal_name,
                    emisorRuc: quote.branchoffice?.ruc,
                    emisorDv: quote.branchoffice?.dv,
                    emisorDireccion: branchOfficeData?.direction,
                    clienteNombre: quote.client_name,
                    clienteRuc: quote.client_ruc,
                    clienteDv: quote.client_dv,
                    clienteDireccion: quote.client_address,
                    clienteTelefono: quote.client_phone,
                    fechaEmision: quote.createdAt ? new Date(quote.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                    puntoFacturacion: '',
                    consultaClaveUrl: '',
                    cufe: '',
                    items: quote.groups,
                    itbmsBreakdown: quote.taxes,
                    metodoPago: '',
                    formaPagoMonto: '',
                    totalPagado: quote.total,
                    tips: quote.tips,
                    subtotal: quote.subtotal,
                    discount: quote.discount,
                    tax: quote.tax,
                    total: quote.total,
                    typeDocument: 'quote',
                    logo: logo,
                    aditional_info: quote.aditional_info || '',
                    note: quote.note || '',
                    transaction_code: quote.transaction_code || ''
                  }}
                />
              }
              fileName={`Cotizacion_${quote.transaction_code}.pdf`}
              className="btn btn-outline-primary btn-sm"
              style={{ color: '#1976d2', borderColor: '#1976d2', background: '#fff' }}
            >
              <i className="uil uil-file-download-alt"></i> Descargar cotizacion
            </PDFDownloadLink>
          </div>
          <button className="btn-close position-absolute top-0 end-0 m-2 p-2" style={{ color: '#199c2b', background: 'transparent', border: 'none', fontSize: 24 }} onClick={onClose} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        {/* Información general */}
        <div className="p-3" style={{ color: '#222', background: '#fff' }}>
          <div className="row">
            {/* Columna info */}
            <div className="col-12 col-md-6 mb-3">
              <div className="fw-bold mb-2" style={{ color: '#1976d2' }}>Información</div>
              <div className="d-flex flex-wrap gap-2 mb-3">
                <div className="bg-light rounded px-3 py-2 text-center">
                  <div style={{ fontSize: 13 }}>Orden</div>
                  <div className="fw-bold">#{quote.transaction_code}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center">
                  <div style={{ fontSize: 13 }}>Sucursal</div>
                  <div className="fw-bold">{quote.branchoffice?.name}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center">
                  <div style={{ fontSize: 13 }}>Máquina</div>
                  <div className="fw-bold">{quote.machine_id || '---'}</div>
                </div>
              </div>
              <div className="fw-bold mb-2" style={{ color: '#1976d2' }}>Datos del cliente:</div>
              <div className="d-flex flex-wrap gap-2 mb-3">
                <div className="bg-light rounded px-3 py-2 text-center" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Nombre</div>
                  <div className="fw-bold">{quote.client_name}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Ruc / dv</div>
                  <div className="fw-bold">Ruc:{quote.client_ruc} - Dv:{quote.client_dv}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Email</div>
                  <div className="fw-bold">{quote.client_email || 'No especificado'}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Teléfono</div>
                  <div className="fw-bold">{quote.client_phone || 'No especificado'}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Direccion</div>
                  <div className="fw-bold">{quote.client_address || 'No especificada'}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center w-100" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Informacion adicional</div>
                  <div className="fw-bold">{quote.aditional_info || 'No especificada'}</div>
                </div>
                <div className="bg-light rounded px-3 py-2 text-center w-100" style={{ minWidth: 120 }}>
                  <div style={{ fontSize: 13 }}>Notas</div>
                  <div className="fw-bold">{quote.note || '---'}</div>
                </div>
              </div>
            </div>
            {/* Columna productos y totales */}
            <div className="col-12 col-md-6 mb-3 d-flex flex-column h-100">
              <div className="fw-bold mb-2" style={{ color: '#1976d2' }}>Productos</div>
              <div className="border rounded p-2 flex-grow-1" style={{ overflowY: 'auto', background: '#fafbfc' }}>
                {quote.groups && quote.groups.length > 0 ? (
                  quote.groups.map((g, idx) => (
                    <div className=" border-bottom py-2" style={{ gap: 8 }}>
                      <div key={g._id || idx} className="d-flex align-items-center justify-content-between " >
                        <div className="d-flex align-items-center" style={{ gap: 8 }}>
                          {g.img && <img loading='lazy' src={buildCloudinaryImageUrl({ url: g.img, width: 300, quality: "auto", type: "image" }) || defaultImage} alt={g.name} style={{ width: 32, height: 32, borderRadius: 6, objectFit: 'cover' }} />}
                          <div>
                            <div className="fw-bold">{g.name}</div>
                            <div style={{ fontSize: 13, color: '#888' }}>{g.description || ''}</div>
                            <div style={{ fontSize: 13, color: '#888' }}>Entrega: {g.delivery_type || '---'}</div>
                          </div>


                        </div>
                        <div className="text-end">
                          <div style={{ fontWeight: 600 }}>
                            x {g.amount} &nbsp; ${parseFloat(g.price).toFixed(2)}
                          </div>
                          <div style={{ fontSize: 13, color: '#888' }}>- ${parseFloat(g.discount || 0).toFixed(2)}</div>
                        </div>
                      </div>
                      <RenderIf isTrue={g.note != ""}>
                        <small className='text-danger p-1' >
                          Nota: {g.note}
                        </small>
                      </RenderIf>
                    </div>

                  ))
                ) : (
                  <div className="text-muted">Sin productos</div>
                )}
              </div>
              {/* Totales debajo del listado de productos */}
              <div className="d-flex flex-column align-items-end mt-3" style={{ fontSize: 15 }}>
                <div>Descuento: <span className="fw-bold">${parseFloat(quote.discount || 0).toFixed(2)}</span></div>
                <div>Subtotal: <span className="fw-bold">${parseFloat(quote.subtotal || 0).toFixed(2)}</span></div>
                <div>Impuesto 0%: <span className="fw-bold">${parseFloat(quote.tax || 0).toFixed(2)}</span></div>
                <div style={{ fontSize: 18, marginTop: 8 }}>Total: <span className="fw-bold">${parseFloat(quote.total || 0).toFixed(2)}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal >
  );
};

export default ModalQuoteDetails;
